/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import Row from 'src/components/Row';
import styled, { ITheme } from 'styled-components';

export const Wrapper = styled(Row)`
    margin: 0;
    display: flex;
    flex-direction: column;
    max-width: 100%;

    .icon-heart svg {
        font-size: 25px;
        color: #3464d8;
        margin-left: 5px;
        margin-top: 5px;
    }

    .icon-heart svg:hover {
        color: #9757d7;
    }

    .icon-ranking-list {
        margin-right: 5px;
    }

    .back-to-all {
        height: 32px;
        margin-top: 20px;
        width: auto;
        padding: 5px 20px;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .col-item-nfts {
        margin-right: 15px;
        display: inline-table !important;
    }

    .list-item .col-item-nfts:hover {
        filter: drop-shadow(rgb(255 225 225 / 35%) 0px 0px 8px);
    }
    // .col-item-nfts {
    //     width: 280px;
    // }
    .bottom-filter {
        margin: initial;
        display: block;
    }
    .home-section {
        width: 100%;
        max-width: 1200px;
        padding: 23px 0px;
        margin-bottom: 50px;
        align-items: center;
    }

    .price-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px 8px 6px;
        height: 30px;
        border: 1px solid #3772ff;
        box-sizing: border-box;
        border-radius: 100px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        color: #3772ff;
    }

    .price-btn {
        .ant-image {
            margin-right: 7px;
        }
    }

    .icon-price {
        justify-content: flex-end !important;
    }

    .rarity {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: ${({ theme }: { theme: ITheme }) => theme.text8};
    }

    .not-for-sale {
        background: #b1b5c4;
    }
    .top-list-filter {
        display: flex;
        margin-bottom: 20px;
    }

    .price {
        justify-content: start !important;
    }
    .total-result-filter {
        margin: auto;
        flex: auto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        margin-left: 5px;
        line-height: 24px;
        display: flex;
        align-items: center;
        color: #777e91;
    }

    .content {
        margin-top: 25px;
        margin-bottom: 160px;
        display: flex;
        flex-direction: row;
        flex: 1;

        .filter {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin-bottom: 105px;
        }
    }

    .list-item {
        display: grid;
        // grid-template-columns: auto auto auto auto;
        flex: 1;
        margin-left: 21px;
        .item {
            max-width: 280px;
            min-width: 280px;
            margin-bottom: 30px;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            overflow: auto;
        }

        .item-title {
            color: ${({ theme }: { theme: ITheme }) => theme.text8};
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
        }

        .item-image {
            img,
            .ant-space {
                width: 100%;
                min-width: 280px;
                max-height: 280px;
                min-height: 280px;
            }

            .ant-space {
                justify-content: center;
                position: absolute;
                top: 0;
                left: 0;
            }
        }

        .item-info {
            padding: 16px 0;
            background: #161616;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }

        .item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            margin-bottom: 5px;
            max-height: 27px;
            background: ${({ theme }: { theme: ITheme }) => theme.dark2};
            color: ${({ theme }: { theme: ITheme }) => theme.text7};

            img {
                max-width: 47px;
                border-radius: 50px;
                border: 2px solid ${({ theme }: { theme: ITheme }) => theme.text6};
            }
        }

        .item-content {
            padding: 0 16px;

            .icon-bnb {
                max-width: 18px;
                margin-right: 3px;
            }
            .icon-rank {
                max-width: 15px;
                filter: invert(1);
            }

            span {
                color: ${({ theme }: { theme: ITheme }) => theme.text7};
            }

            img {
                max-width: 30px;
            }

            .item-btn {
                margin-top: 12px;
                height: 32px !important;
            }
        }

        .ant-col {
            display: flex;
            // justify-content: center;
            // align-items: center;
        }
    }
    .col-grid {
        flex-wrap: wrap;
        min-width: 580px;
    }
    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        min-width: unset;
        padding-left: 20px;
        padding-right: 20px;

        .top-list-filter{
            display: contents;
        }
        .total-result-filter{
            justify-content: center;
        }

        .list-item {
            margin-top: 0px;
            margin-left: 0px;
        }

        .item-image img{
            max-height: 100% !important;
        }
        .list-item .col-item-nfts{
            display: unset;
        }

        .content {
            margin-top: 20px;
        }

        .wallet {
            display: flex;
            .favorite-text {
                font-size: 22px;
                line-height: 30px;
                text-align: start !important
            }

            .btn-connect-wallet {
                margin-top: 20px;
            }
        }
        .list-item .item {
            max-width: 300px;
        }
        .ant-pagination {
            display: flex;
            justify-content: center;
        }

        .col-item-nfts {
            margin-right: 15px;
            display: flex !important;
            justify-content: center;
        }
    `}
`;
